import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query/react'
import Style from '../styles/pages/Reservation.module.scss'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import arrowLeft from '../shared/images/icon-arrow-left.svg'
import { Box, Typography, List, ListItem , Avatar} from '@mui/material'
import arrow from '../shared/images/arrow-down.svg'
import { RootState } from '../store/GlobalStore'
import { useGetUserReservationQuery} from '../services/ReservationAPI'
import { environment } from '../utils/Environment'
import { Reservation } from '../utils/Interface'
const ReservationsPage: React.FC = () => {
    const authState = useSelector((state: RootState) => state.Auth)
    const { id } = useParams<{ id: string }>();
     // Ne pas appeler la query si l'utilisateur n'est pas défini
     const userEmail = authState?.user?.email
     const [reservationData, setReservationData] = useState<Reservation>();
     const [activeTab, setActiveTab] = useState<'incoming' | 'past'>('incoming');

    useEffect(() => {
        if (authState?.reservations !== null) {
            const data = authState?.reservations;
            console.log("id   ====> " + id)
            // Filtrer la réservation spécifique par son ID
            const updatedData = data.map(reservation => ({
                ...reservation,
                Bookings: reservation.Bookings.map(booking => ({
                    ...booking,
                    // Si forfaitCode est manquant, essayez de le retrouver
                    forfaitCode: (booking.forfaitCode === '') ? getForfaitCode(reservation.Bookings, booking.ressourceTypeCode) : booking.forfaitCode
                }))
            }));


            const specificReservation = updatedData.find(reservation => Number(reservation.asterioId) === Number(id));
            console.log(data)

            
            if (specificReservation !== undefined) {

                /*specificReservation.Bookings.map(booking => ({
                    ...booking,
                    // Si forfaitCode est manquant, essayez de le retrouver
                    forfaitCode: booking.forfaitCode || getForfaitCode(specificReservation.Bookings, booking.ressourceTypeCode)
                }));
                console.log(specificReservation)*/
                setReservationData(specificReservation);
            }
        }
    }, [authState?.reservations, id, activeTab]);

    const getForfaitCode = (bookings : any, ressourceTypeCode : string) => {
        console.log(ressourceTypeCode)
        const similarBooking = bookings.find(
            (booking : any) => booking.ressourceTypeCode === ressourceTypeCode  && booking.forfaitCode && booking.forfaitCode !== ''
        );
        return similarBooking ? similarBooking.forfaitCode : null;
    };
    

    return (
        <div className={Style.MainContainer}>
            <div className={Style.TopContainer}>
                <Link to='/all-reservations'>
                    <button className={Style.arrowButton}>
                        <img src={arrowLeft} alt='Arrow Left' />
                    </button>
                </Link>
                <h2>Hébergements</h2>
                <p>Retrouvez les informations liées à votre réservation</p>
            </div>
            <div>
            {/*<div className={Style.Tabs}>
                <button
                    className={`${Style.incomingButton} ${activeTab === 'incoming' ? Style.active : ''}`}
                    onClick={() => setActiveTab('incoming')}
                >
                    À venir
                </button>
                <button
                    className={`${Style.pastButton} ${activeTab === 'past' ? Style.active : ''}`}
                    onClick={() => setActiveTab('past')}
                >
                    Passées
                </button>
            </div>*/}
                <div className={Style.DesktopFormField}>
                    <Box className={Style.AccountBox}>
                    <List>
                    {reservationData ? (
                                reservationData.Bookings
                                    .map((booking, bookingIndex) => (
                                        <ListItem
                                            key={`${bookingIndex}`}
                                            className={`${Style.AnimationItem} ${booking.cancelled ? Style.cancelled : ''}`}
                                            component={!booking.cancelled ? Link : 'div'}
                                            to={`/booking/${booking.bookingId}`}
                                        >
                                            <div className={Style.AnimationContent}>
                                                <img
                                                    src={`${process.env.REACT_APP_BASE_URL}${booking.displayImage}` || 'default-image.png'}
                                                    alt={booking.ressourceTypeCode}
                                                    className={Style.AnimationImage}
                                                />
                                                <div className={Style.AnimationInfo}>
                                                    <div className={Style.Lieu}>Les Settons</div>
                                                    <Typography variant="body2" className={Style.strong}>
                                                        {booking.ressourceTypeLabel}
                                                    </Typography>
                                                    <Typography variant="body2" className={Style.thin}>
                                                        {new Date(booking.startDate).toLocaleDateString('fr-FR', {
                                                            day: 'numeric',
                                                            month: 'short',
                                                        })}{' '}
                                                        - {new Date(booking.endDate).toLocaleDateString('fr-FR', {
                                                            day: 'numeric',
                                                            month: 'short',
                                                        })}
                                                    </Typography>
                                                    <Typography variant="body2" className={Style.thin}>
                                                        {booking.nbAdults > 0 ? `${booking.nbAdults} adulte${booking.nbAdults > 1 ? 's' : ''}` : ''}
                                                        {booking.nbAdults > 0 && booking.nbChilds > 0 ? ' - ' : ''}
                                                        {booking.nbChilds > 0 ? `${booking.nbChilds} enfant${booking.nbChilds > 1 ? 's' : ''}` : ''}
                                                    </Typography>
                                                    <Typography variant="body2" className={Style.strong}>
                                                        {reservationData.Folios.find(folio => folio.productCode === booking.forfaitCode)?.unitPrice || ''} 
                                                        {reservationData.Folios.find(folio => folio.productCode === booking.forfaitCode) ? '€ par nuit' : ''}
                                                    </Typography>
                                                    <Typography variant="body2" className={Style.redStrong}>
                                                        {(booking.cancelled) ? 'ANNULE' : ''} 
                                                    </Typography>
                                                </div>
                                            </div>
                                            <img src={arrow} alt='arrow' className={Style.ArrowIcon} />
                                        </ListItem>
                                    ))
                        ) : (
                            <Typography>
                                {activeTab === 'incoming' ? 'Aucune réservation à venir trouvée' : 'Aucune réservation passée trouvée'}
                            </Typography>
                        )}
                        </List>
                    </Box>
                </div>
            </div>
        </div>
    )
}

export default ReservationsPage